import { 
    REFERRAL_FAIL, REFERRAL_REQUEST, REFERRAL_SUCCESS, REFERRAL_EDIT_FAIL, REFERRAL_EDIT_REQUEST, REFERRAL_EDIT_SUCCESS
  } from '../constants/referralConstants'

const initialState = {
    validation: [],
    error: []
}

export const referralListReducer = (state = initialState, action) => {
    switch (action.type) {
        case REFERRAL_REQUEST:
        return { ...state, loading: true, error: [], validation: [] }
        case REFERRAL_SUCCESS:
        return { ...state,loading: false, referral: action.payload, listsReferral: action.payload.data }
        case REFERRAL_FAIL:
        return { ...state, loading: false, error: action.payload }
        default:
        return state
    }
}

export const referralEditReducer = (state = initialState, action) => {
    switch (action.type) {
        case REFERRAL_EDIT_REQUEST:
        return { ...state, loading: true, error: [], validation: [] }
        case REFERRAL_EDIT_SUCCESS:
        return { ...state, loading: false, referral: action.payload.data }
        case REFERRAL_EDIT_FAIL:
        return { ...state, loading: false, error: action.payload }
        default:
        return state
    }
}